import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import CreateEmployee from "@/features/employees/create-employee/crete-employee-modal";
import EmployeesTable from "@/features/employees/employees-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute("/_app/(multi-location)/admin/employees/")(
  {
    component: () => <EmployeesPage />,
  },
);

function EmployeesPage() {
  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Personell</Trans>
        </h1>

        <Can I="create" a="Employee">
          <CreateEmployee />
        </Can>
      </Flex>

      <EmployeesTable />
    </Box>
  );
}
